import { TooltipDesktop, Label } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { BACKGROUND_COLOR, TEXT_COLOR, ICON } from '../../../../constants/newbuildingLabels';
import { ILabel } from '../../../../types/newbuildingHeader';

interface ITooltipLabelProps {
  label: ILabel;
}

export const TooltipLabel: React.FC<ITooltipLabelProps> = ({ label }) => {
  const { type, description, title } = label;
  const labelProps = {
    background: BACKGROUND_COLOR[type],
    color: TEXT_COLOR[type],
    icon: ICON[type],
  };

  return (
    <div className={styles['tooltip']}>
      {description ? (
        <TooltipDesktop
          title={<div className={styles['description']}>{description}</div>}
          theme="black"
          placement="bottom"
        >
          <Label {...labelProps}>{title}</Label>
        </TooltipDesktop>
      ) : (
        <Label {...labelProps}>{title}</Label>
      )}
    </div>
  );
};
